import { reactive } from 'vue'
import { notificación } from '@/../../cliente_comun/utilidades'
import { _firestoreCuenta } from '@/../../cliente_comun/fuentes'
import { ServicioDeListado } from '@/../../cliente_comun/servicio_listado'
import { ServicioDeGuardado } from '@/../../cliente_comun/servicio_guardado'

/**
 * @typedef UbicaciónDePuntoDeVenta
 * @type {object}
 * @property {string} nombre - Nombre.
 * @property {string} descripción - Descripción.
 */

let servicioDeListado = null
let servicioDeGuardado = null

/** @type {UbicaciónDePuntoDeVenta} */
export const ubicaciónDePuntoDeVenta = reactive({
	nombre: '',
	descripción: '',
})

function _refListado(identificadorDePuntoDeVenta) {
	return _firestoreCuenta.collection('puntosDeVenta').doc(identificadorDePuntoDeVenta).collection('ubicacionesDePuntoDeVenta').orderBy('creación.fecha', 'desc')
}

/**
 * 
 * @param {string} identificadorDePuntoDeVenta 
 * @returns {Object}
 */
export function inicializarServicioDeListado(identificadorDePuntoDeVenta) {
	if (servicioDeListado) {
		listarUbicacionesDePuntoDeVenta(identificadorDePuntoDeVenta)
		return servicioDeListado
	}

	const ref = _refListado(identificadorDePuntoDeVenta)
	servicioDeListado = new ServicioDeListado(ref)

	return servicioDeListado
}

/**
 * 
 * @param {string} identificadorDePuntoDeVenta
 * @returns {void}
 */
export function listarUbicacionesDePuntoDeVenta(identificadorDePuntoDeVenta) {
	const ref = _refListado(identificadorDePuntoDeVenta)
	servicioDeListado.listar(ref)
}

/**
 * 
 * @param {string} identificadorDePuntoDeVenta
 * @returns {ServicioDeGuardado}
 */
export function inicializarServicioDeGuardado(identificadorDePuntoDeVenta) {
	const recursoBase = `/administracion/v1/puntos-de-venta/${identificadorDePuntoDeVenta}/ubicaciones`
	servicioDeGuardado = new ServicioDeGuardado(recursoBase, verificarDatos)
	return servicioDeGuardado
}

export function desconectarServicioDeListado() {
	if (servicioDeListado) {
		servicioDeListado.desconectar()
		servicioDeListado = null
	}
}

/**
 * 
 * @param {UbicaciónDePuntoDeVenta} datos 
 */
function verificarDatos(datos) {
	datos.nombre = (datos.nombre || '').trim()
	datos.descripción = (datos.descripción || '').trim()

	if (!datos.nombre) {
		notificación.error('Falta el nombre.')
		throw null
	}
}

export function establecerDatos(datos) {
	ubicaciónDePuntoDeVenta.nombre = datos.nombre || ''
	ubicaciónDePuntoDeVenta.descripción = datos.descripción || ''
}

export function limpiarObjeto() {
	ubicaciónDePuntoDeVenta.nombre = ''
	ubicaciónDePuntoDeVenta.descripción = ''
}
